// @todo get webpack external working for Sentry/Raven
const Sentry = window.Raven;

export const addToErrReportContext = newContext => {
  if (!newContext || typeof newContext !== 'object') {
    throw new TypeError('Invalid context data passed to addToErrReportContext');
  }

  if (Sentry) {
    const oldContext = Sentry.getContext().user || {};
    Sentry.setUserContext({ ...oldContext, ...newContext });
  }
};

export const addToErrReportTags = newTag => {
  if (!newTag || typeof newTag !== 'object') {
    throw new TypeError('Invalid context data passed to addToErrReportContext');
  }

  if (Sentry) {
    Sentry.setTagsContext(newTag);
  }
};

export const reportError = (error, info) => {
  // eslint-disable-next-line no-console
  console.error(error);
  if (Sentry && Sentry.captureException) {
    Sentry.captureException(error, { extra: { info: JSON.stringify(info) } });
  }
};

export const configureErrorReporting = (commitHash, env) => {
  if (Sentry) {
    Sentry.config(
      'https://f8b92206489e44de85c4d2740a7fb9ef@sentry.io/1250866',
      {
        release: commitHash,
        environment: env || 'staging',
      }
    ).install();
  }
};
